"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var image_dimensions_1 = require("../../controls/image-dimensions");
wp.customize.controlConstructor['epsilon-image-dimensions'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new image_dimensions_1.EpsilonImageDimensions(control);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/image-dimensions.ts
// module id = 17
// module chunks = 0